/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2019-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React, {Component} from 'react';
import {validated} from 'react-custom-validation';
import Helmet from 'react-helmet';
import {ButtonToolbar, Col, Row} from 'react-bootstrap';
import $ from 'jquery';

import Input from '@corero/ssp-ui-components/components/form/input/Input';
import SimpleButton from '@corero/ssp-ui-components/components/buttons/SimpleButton/SimpleButton';
import BlueButton from '@corero/ssp-ui-components/components/buttons/BlueButton/BlueButton';

import validationRules from '@corero/ssp-ui-components/core/validation.js';
import {store} from '@corero/ssp-ui-components/stores/AuthStore';
import {default as withRouter} from '@corero/ssp-ui-components/utils/withRouter';
import '../forgotPassword/forgotPassword.scss';
import sharedConfig from '@corero/ssp-ui-components/core/sharedConfig';

import {actions as themeActions, store as themeStore} from "@corero/ssp-ui-components/stores/AppConfigStore"

class ApplyToken extends Component {
    constructor(props) {
        super(props);
        this.state = { fields: { token:"" },  text_color : '', error_text_color : ''};
        $("body").addClass("forgot-password-page");
    }

    componentDidMount() {
        $("body").addClass("forgot-password-page");
        $(".forgot-password-page").css("background-image", "url(" + sharedConfig.apis.theme + "/backgroundImage)")
        themeStore.addChangeListener((this._onThemeConfigChange))
        themeActions.fetchThemeConfiguration();
    }

    _onThemeConfigChange = () =>{
        this.setState({
            login_color_text : (themeStore.getThemeConfiguration()).login_color_text,
        })
    }

    componentWillUnmount = () => {
        $("body").removeClass("forgot-password-page");
        $('.forgot-password-page').css('background-image', '');
        themeStore.removeChangeListener((this._onThemeConfigChange))
    };

    fieldChange = (field, value) => {
        const newFields = { ...this.state.fields, [field]: value };
        this.setState({ fields: newFields });
    };

    cancel = () => {
        this.props.router.navigate('/login');
    };

    tokenFormSubmit = () => {
        store.validatePasswordResetToken(this.state.fields.token, this.props.router.navigate);
    };

    render() {
        return (
            <div className="forgot-password-container">
                <div className="forgot-password-inner-container">
                    <div className="col-sm-12">
                        <Helmet defer={false} title="Apply Token" />
                        <h1 style={{color : this.state.login_color_text}} className="text-center">Change Password</h1>
                        <p style={{color : this.state.login_color_text}} className="password-info mt40">
                            If you have a password token enter it here. You will then be prompted to set a new password
                        </p>

                        <Row className="mt20">
                            <Col sm={{span: 4, offset: 4}}>
                                <Form
                                    fields={this.state.fields}
                                    onCancel={this.cancel}
                                    onChange={this.fieldChange}
                                    onValid={this.tokenFormSubmit} // eslint-disable-line
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {button_color : '', error_text_color : '', text_color :'', btn_foreground_color : ''};

    }
    componentDidMount() {
        themeStore.addChangeListener((this._onThemeConfigChange))
        themeActions.fetchThemeConfiguration();
    }

    _onThemeConfigChange = () =>{
        this.setState({
            login_color_button : (themeStore.getThemeConfiguration()).login_color_button,
            login_color_error_text : (themeStore.getThemeConfiguration()).login_color_error_text,
            login_color_btn_foreground : (themeStore.getThemeConfiguration()).login_color_btn_foreground,
            login_color_cancel_btn: (themeStore.getThemeConfiguration()).login_color_cancel_btn,
            login_color_cancel_btn_foreground: (themeStore.getThemeConfiguration()).login_color_cancel_btn_foreground,
            login_button_border_color: (themeStore.getThemeConfiguration()).login_button_border_color,
            login_button_border_width: (themeStore.getThemeConfiguration()).login_button_border_width,
        })
    }

    componentWillUnmount = () => {
        themeStore.removeChangeListener((this._onThemeConfigChange))
    };


    render() {
        const {$field, $validation, onValid, onInvalid, onChange} = this.props;
        const fields = { $field, $validation, onChange, fields: this.props.fields };
        return (
            <form onSubmit={(e) => { e.preventDefault(); this.props.$submit(onValid, onInvalid) }}>
                <Input errorColor={this.state.login_color_error_text} type="text" name="token" placeholder="Token" fieldSizes={{ xs: 12 }} {...fields} />
                <ButtonToolbar>
                    <SimpleButton style={{background : this.state.login_color_cancel_btn, border: "none", color: this.state.login_color_cancel_btn_foreground}} title="Cancel" click={(e) => { e.preventDefault(); this.props.onCancel(); }} />
                    <BlueButton style={{
                        background : this.state.login_color_button,
                        color: this.state.login_color_btn_foreground,
                        border: !Number.isNaN(this.state.login_button_border_width) && this.state.login_button_border_color
                            ? `${this.state.login_button_border_width}px solid ${this.state.login_button_border_color}`
                            : "none"
                    }} title="Apply" />
                </ButtonToolbar>
            </form>
        );
    }
}

Form = validated(validationConfig)(Form);

function validationConfig(props) {
    const { token } = props.fields;
    const validations = {
        token: [[validationRules.required, token]]
    };

    return {
        fields: ['token'],
        validations: validations
    }
}

export default withRouter(ApplyToken);
